// import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react';

// import COLORS from '../utils/colors'
// import { card as cardStyle } from '../utils/styles'

import { Formik } from "formik";
import * as yup from "yup";
import { Form, Button, Row, Col, Alert } from 'react-bootstrap';

import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import CheckIcon from '@material-ui/icons/Check';
import PhoneIcon from '@material-ui/icons/Phone';

import { colorPens } from '../utils/colors';

const schema = yup.object({
    username: yup
        .string()
        .email("Username must be a valid email address")
        .required("E-mail address is a required field"),
    password: yup
        .string()
        .min(12)
        .required("Please enter your password")
})

const SignInForm = (props) => {
    let { wipFormData } = props;

    return (
        <Formik 
            validationSchema={schema} 
            onSubmit={(values, actions) => {
                props.onSubmit(values);
            }}
            initialValues={{ 
                username: wipFormData.username !== undefined ? wipFormData.username : '', 
                password: '' }}>
            {({
                handleSubmit,
                handleChange,
                handleBlur,
                values,
                touched,
                isValid,
                errors,
            }) => (
                <Row className="justify-content-center">
                    <Col md={5} style={{ backgroundColor: colorPens.light, border: '1px solid '+ colorPens.main, borderRadius: '5px' }}>
                        <Form noValidate onSubmit={handleSubmit}>
                        <Row className="justify-content-center">
                            <Col md={11}>
                                <br />
                                <h4>Sign in to your account</h4>
                                <br />
                            </Col>
                        </Row>
                        {/* <Row className="justify-content-center">
                            <Col md={8}>
                                <h5>Step 2/2 - Please confirm your e-mail address using the verification code in the email.</h5><br />
                            </Col>
                        </Row> */}
                        <Form.Row className="justify-content-center">
                            <Form.Group as={Col} md={11} controlId="validationFormik101">
                                <Form.Label>E-mail address *</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="username"
                                    value={values.username}
                                    onChange={handleChange}
                                    isValid={touched.username && !errors.username}
                                    isInvalid={touched.username && errors.username}
                                    placeholder="Enter your email address"
                                />
                                <Form.Control.Feedback type="invalid">{errors.username}</Form.Control.Feedback>
                            </Form.Group>
                        </Form.Row>
                        <Form.Row className="justify-content-center">
                            <Form.Group as={Col} md={11} controlId="validationFormik102">
                                <Form.Label>Password *</Form.Label>
                                <Form.Control
                                    type="password"
                                    name="password"
                                    value={values.password}
                                    onChange={handleChange}
                                    isValid={touched.password && !errors.password}
                                    isInvalid={touched.password && errors.password}
                                    placeholder="Enter your password"
                                />
                                <Form.Control.Feedback type="invalid">{errors.password}</Form.Control.Feedback>
                                <Form.Text className="text-muted">Forgot your password? <Button variant="link" size="sm" onClick={() => {window.location.href='/account/resetPassword'}}>Reset Password</Button></Form.Text>
                            </Form.Group>
                        </Form.Row>
                        <br />
                        <Row className="justify-content-center">
                            <Col md={6}>&nbsp;</Col>
                            <Col md={5}><Button variant="primary" type="submit">Sign In</Button></Col>
                        </Row>
                        <br />
                    </Form>

                    </Col>
                </Row>
            )}
        </Formik>
    );
}

export default SignInForm;